export default "__VITE_ASSET__C48MZAc5__"